// extracted by mini-css-extract-plugin
export default {"progressBar":"InputRange_progressBar__+OXWu"};